<template>
  <v-container fluid>
    <label class="title">
      Colunas Virtuais
    </label>
    <v-data-table
      class="default-table-height elevation-1"
      :headers="columnHeaders"
      :items="virtualColumns"
      :single-expand="true"
      :items-per-page="-1"
      item-key="order"
      hide-default-footer
      fixed-header
      hide-default-header
      :height="virtualColumnsLength > 10 ? 550 : null"
    >
      <template v-slot:no-data>
        <span>Não há colunas virtuais</span>
      </template>
      <template v-slot:header="{ props }">
        <thead class="v-data-table-header">
          <tr class="table-header">
            <th
              :style="`
                background-color: var(--v-muted-foreground-base) !important;
                text-align: center;
                width: ${header.width}px;
              `"
              v-for="header in props.headers"
              :key="header.text"
            >
              <label
                class="label base-color"
                v-if="header.text !== 'Ações'"
              >
                {{ header.text }}
              </label>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:[`item.order`]="{ item: column }">
        <v-container
          fluid
        >
          <v-row
            no-gutters
          >
            <v-col cols="3" style="width: 20px; max-width: 20px;" />

            <v-col
              cols="6"
              class="d-flex justify-center"
               style="width: 50px; max-width: 50px;"
            >
              <span
                class="d-flex align-center"
                style="height: 24px;"
              >
                {{ column.order }}
              </span>
            </v-col>

            <v-col
              cols="3"
              style="width: 20px; max-width: 20px;"
            >
              <HintIcon
                v-if="setTransformationColumnInfo(column) !== false"
                :info="setTransformationColumnInfo(column)"
                :icon="setColumnIcon(column)"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <v-row
          justify="center"
          class="my-0"
        >
          <v-col
            cols="12"
            lg="9"
            align="center"
            class="py-0 my-0"
          >
            <v-text-field
              v-model="item.name"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              :rules="[rule.required]"
              maxlength="30"
              readonly
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.function`]="{ item }">
        <v-row
          justify="center"
          class="my-0"
        >
          <v-col
            cols="12"
            lg="9"
            align="center"
            class="py-0 my-0"
          >
            <v-autocomplete
              v-model="item.function"
              :items="functions"
              item-text="text"
              item-value="value"
              placeholder="Informe"
              class="mt-6"
              color="primary"
              dense
              solo
              :rules="[
                rule.required,
                hasValueBeenAdded(item)
              ]"
              validate-on-blur
            />
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <SnackbarCustomize ref="SnackbarCustomize" />
  </v-container>
</template>

<script>
import Rules from '@/shared/validators/formRules';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import { mapGetters } from 'vuex';
import HintIcon from '@/components/HintIcon/HintIcon.vue';
import LayoutImportMixin from '@/shared/mixins/layoutImport/layoutImportMixin';

export default {
  name: "CalculatedFieldTable",

  components: {
    SnackbarCustomize,
    HintIcon,
  },

  data: () => ({
    layout: {},
    formatter: null,
    transformationParameter: {},
    isVisualization: false,
    snackbar: {
      type: '',
      show: false,
      text: '',
    },
    functions: [
      {
        value: 'FAMILY_SEQUENCIAL',
        text: 'Sequencial Família',
      },
      {
        value: 'MEMBER_OF_FAMILY_SEQUENCIAL',
        text: 'Seq. Integrante Família',
      },
      {
        value: 'LINE_SEQUENCIAL',
        text: 'Sequencial Arquivo',
      },
    ],
    columnHeaders: [
      {
        text: 'Campo',
        value: 'order',
        align: 'center',
        sortable: false,
        width: 150,
      },
      {
        text: 'Nome',
        value: 'name',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Função',
        value: 'function',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  props: {
    propsLayout: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    isCopy: {
      type: Boolean,
      required: true,
    },
  },

  watch: {
    propsLayout: {
      handler(val) {
        if (val) {
          this.layout = val;
        }
      },
    },
  },

  mixins: [
    LayoutImportMixin,
  ],

  mounted() {
    if (sessionStorage.getItem('visualization')) {
      this.isVisualization = true;
    }
  },

  computed: {
    ...mapGetters({
      layoutData: 'layout-import/layout',
    }),
    columnHeadersComputed() {
      return this.columnHeaders;
    },
    virtualColumns() {
      if (
        this.layout &&
        this.layout.columns &&
        this.layout.columns.length > 0
      ) {
        const virtualColumns = this.layout.columns.filter(
          (column) => column.columnType === 'VIRTUAL'
        );
        return virtualColumns;
      }

      return [];
    },
    virtualColumnsLength() {
      return this.virtualColumns.length;
    },
  },

  methods: {
    getTextFromFunctions(value) {
      const item = this.functions.find((func) => func.value === value);
      return item ? item.text : null;
    },

    hasValueBeenAdded(value) {
      const repeatedItems = this.virtualColumns.filter(item => item.function === value.function);
      if (repeatedItems.length > 1) {
        const lastItem = repeatedItems.reduce((last, current) => {
          return current.sequencial > last.sequencial ? current : last;
        });
        if (lastItem.sequencial === value.sequencial) {
          return this.getTextFromFunctions(value.function) + ' já adicionado, utilize outro';
        }
      }
      return true;
    },
  },

  created() {
    this.rule = new Rules();
  },
};
</script>

<style scoped>
.isSelectedTransformation {
  background-color: color-mix(in srgb, var(--v-error-base), transparent 15%);
  color: var(--v-error-base);
}
</style>
